// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__hCeP6","text":"styles_text__B21cn","buttonWrapper":"styles_buttonWrapper__2_ZCE","cancelBonus":"styles_cancelBonus__sFnBq"};